import * as auth from "../js-core/conn/auth/auth-main"

export default function preload() {
  authRedirect()
}

function authRedirect() {
  if (!auth.checkIfAuth() && window.location.hash.indexOf('auth') === -1) {
    window.location.href = "#/brite-host/auth/login"
    return
  }
}